export const GEOCERCA_COLOR_PALETTE = {
    1: { stroke: "#800080", fill: "#E1BEE7" },
    2: { stroke: "#F57C00", fill: "#FFE0B2" },
    3: { stroke: "#388E3C", fill: "#C8E6C9" },
};

export const getGeocercaColors = (geocerca) => {
    const rawCategory =
        geocerca?.FKCatGeoCerca ??
        geocerca?.fkCatGeocerca ??
        geocerca?.FK_CAT_GEO ??
        geocerca?.tipo ??
        geocerca?.Tipo;
    const category = Number.parseInt(rawCategory, 10);
    return GEOCERCA_COLOR_PALETTE[category] || GEOCERCA_COLOR_PALETTE[1];
};
